export default "__VITE_ASSET__BrTli3O4__"